import Model from './Model';

export default class PageTrackingLink extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'page-tracking-links';
  }
}
